import script from "./AppTokenIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTokenIcon.vue?vue&type=script&setup=true&lang=ts"

import "./AppTokenIcon.vue?vue&type=style&index=0&id=1e819c44&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/EthVM/EthVM/v2/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e819c44"]])

export default __exports__